// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".V9PCEuMPuFulN6 {\n  border-top: 1px solid var(--ds-border, rgba(9, 30, 66, 0.13));\n  margin: 10px 0 0;\n  padding-top: 8px;\n}\n.uSkFVj_Rnd9il8 {\n  width: 100%;\n  cursor: pointer;\n  display: block;\n  font-weight: normal;\n  padding: 6px 12px;\n  position: relative;\n  margin: 0 -12px;\n  text-decoration: none;\n  background-color: transparent;\n  color: var(--ds-text, #172B4D);\n}\n.uSkFVj_Rnd9il8:hover {\n  background-color: var(--ds-background-neutral-subtle-hovered, rgba(9, 30, 66, 0.04));\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaDivider": "V9PCEuMPuFulN6",
	"ctaButton": "uSkFVj_Rnd9il8"
};
export default ___CSS_LOADER_EXPORT___;
